import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { DialogModule } from '../dialog/dialog.module';
import { FormMasterModule } from '../form-master/form-master.module';
import { SharedModule } from '../shared/shared.module';
import { SendingDialogComponent } from './components/sending-dialog/sending-dialog.component';
import { MessageDeliveryComponent } from './message-delivery.component';
import { I2gNgUiModule } from 'i2g-ng-ui';
import { FileAttachmentComponent } from './components/file-attachment/file-attachment.component';
import { I2gNgTrackingModule } from 'i2g-ng-tracking';

const components = [
  MessageDeliveryComponent,
  SendingDialogComponent,
  FileAttachmentComponent,
];

@NgModule({
  imports: [
    CommonModule,
    FormMasterModule,
    SharedModule,
    DialogModule,
    I2gNgUiModule,
    I2gNgTrackingModule,
  ],
  declarations: [...components],
  exports: [...components],
})
export class MessageDeliveryModule {}
